import CollectionModule from 'client/store/modules/CollectionModule';
import ProvidersApi from 'client/api/v2/ProvidersApi';

export class ProvidersCollectionClass extends CollectionModule {
  extractModule() {
    const module = super.extractModule();

    module.actions.setProviderId = (...params) => this.setProviderId(...params);

    return module;
  }

  // --------------------------------------------------------------------------
  // State
  // --------------------------------------------------------------------------

  getInitialState() {
    return super.getInitialState();
  }

  // --------------------------------------------------------------------------
  // Actions
  // --------------------------------------------------------------------------

  /**
   * @description Override the base class method to check for a Provider Id
   * before fetching the collection. If they are not a Provider, an error message
   * will be displayed in the ItemTable and the collection will be empty.
   */
  fetchCollection(context) {
    if (this.Api.providerId) {
      return super.fetchCollection(context);
    }
    return [];
  }

  /**
   * @description Override this base class method also to check for a Provider Id
   * before refreshing the collection.
   */
  refreshCollection(context) {
    if (this.Api.providerId) {
      return super.refreshCollection(context);
    }
    return [];
  }

  /**
   * @description Set the providerId for this collection.
   */
  setProviderId(context, providerId) {
    this.Api.setProviderId(providerId);
  }
}

export default new ProvidersCollectionClass(ProvidersApi, 'id', 'email').extractModule();
